import i18n from '@/plugins/i18n';

const metricsORGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.host-cpu-utilization'),
      header: {
        title: i18n.global.t('dbm.host-cpu-utilization'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_db_host_cpu_utilization',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.percentage'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.percentage'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.disk-read-time-per-second'),
      header: {
        title: i18n.global.t('dbm.disk-read-time-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_disk_read_time_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.disk-write-time-per-second'),
      header: {
        title: i18n.global.t('dbm.disk-write-time-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_disk_write_time_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'ms',
      },
    },

    {
      width: '48%',
      title: i18n.global.t(
        'dbm.number-of-long-running-greater-than-60s-queries',
      ),
      header: {
        title: i18n.global.t(
          'dbm.number-of-long-running-greater-than-60s-queries',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_long_running_queries',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.long-running-queries'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.long-running-queries'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.user-transaction'),
      header: {
        title: i18n.global.t('dbm.user-transaction'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_query_transactions_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.user-transaction-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.user-transaction-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-redo-log-file-switch'),
      header: {
        title: i18n.global.t('dbm.number-of-redo-log-file-switch'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_redo_log_log_file_switch',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-redo-log-file-switch'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-redo-log-file-switch'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.number-of-redo-log-file-waits'),
      header: {
        title: i18n.global.t('dbm.number-of-redo-log-file-waits'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_redo_log_waits',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-redo-log-file-waits'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-redo-log-file-waits'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.hit-ratio-for-the-sga'),
      header: {
        title: i18n.global.t('dbm.hit-ratio-for-the-sga'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_oracle_sga_hit_ratio',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.hit-ratio-for-the-sga'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.hit-ratio-for-the-sga'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.sga-cacheable-memory-per-statement'),
      header: {
        title: i18n.global.t('dbm.sga-cacheable-memory-per-statement'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_oracle_sga_shared_pool_library_cache_shareable_memory_per_statement_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      aggregation: '/',
      aggregationNum: '100',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'MB',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.sga-cacheable-memory-per-user'),
      header: {
        title: i18n.global.t('dbm.sga-cacheable-memory-per-user'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_oracle_sga_shared_pool_library_cache_shareable_memory_per_user_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      aggregation: '/',
      aggregationNum: '100',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'MB',
      },
    },
  ],
});

export default metricsORGraphs;
